import { Link } from 'react-router-dom';
import { AlertCircle } from 'lucide-react';
import { useMySignatureUrl } from '../../hooks/queries/useSignatureCircuits';

export function MissingSignatureBanner() {
  const { data: url, isLoading } = useMySignatureUrl();
  if (isLoading || url) return null;

  return (
    <div className="rounded-md border border-amber-300 bg-amber-50 px-3 py-2.5 text-sm flex items-start gap-2 mb-4">
      <AlertCircle className="w-4 h-4 text-amber-600 mt-0.5 flex-shrink-0" />
      <div className="flex-1 min-w-0 text-amber-900">
        Vous n'avez pas encore enregistré votre signature. Vous pourrez consulter le parapheur,
        mais pas signer de document tant qu'elle n'est pas enregistrée.{' '}
        <Link to="/profil" className="font-medium underline hover:opacity-80">
          Enregistrer ma signature
        </Link>
      </div>
    </div>
  );
}
